/** @format */

import React, { useContext, useState } from 'react';
import styles from './Wallet.module.css';
import { SupportEmail } from '../../common/SupportFooter';
import { Header } from '../../common/Header';
import { AmountSection } from '../../common/AmountSection';
import { RoutingContext } from '../../../context/Router';
import { MobileWrapper } from '../../common/MobileWrapper';
import { Login } from './screens/Login';
import { Details } from './screens/Details';
import { sendMessage } from '../../../context/utils';
import { StatusMessage } from '../../StatusMessage';
import { BackToMethods } from '../../common/BackToMethods';
import { StatusContext } from '../../../context/Status';
import { ErrorAlertContext } from '../../../context/ErrorAlert';
import axios from 'axios';

export type WalletPayProps = {
	// username: string, password: string
	[x: string]: any;
};

export const BusinessWallet = () => {
	const { email, currency, amount, merchantKey, payData } =
		useContext(RoutingContext);
	const { setPageTransactionStatus } = useContext(StatusContext);

	const { onShowAlert } = useContext(ErrorAlertContext);

	const [userEmail, setUserEmail] = useState('');
	const [fullname, setFullname] = useState('');
	const [tabDisplayed, setTabDisplayed] = useState('login');
	const [isLoading, setIsLoading] = useState(false);
	const [emailError, setEmailError] = useState('');
    let mailformat = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}(?:\.[a-zA-Z]{2,})?$/;

	const onPay = async (data?: WalletPayProps) => {
		if (!data?.username.match(mailformat) || !data?.username) {
			setEmailError('Please enter a valid email address');
		} else {
			setIsLoading(true);
			try {
				const response = await axios(
					`${process.env.REACT_APP_API_URL}pay/wallet/popup`,
					{
						method: 'POST',
						headers: {
							'Content-Type': 'application/json',
							Accept: 'application/json',
							'x-auth-token': merchantKey,
                            ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                                "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
                              })
						},
						data,
					}
				);
				const responseData = response.data;

				if (responseData.status !== 'error') {
					setTabDisplayed('details');
					setUserEmail(responseData.email);
					setFullname(`${responseData.firstName} ${responseData.lastName}`);
				}
			} catch (err: any) {
				// @ts-ignore
				if (err.response.data.error === 'Bad credentials') {
					onShowAlert(err, 'Wrong username or password');
				} else {
					// @ts-ignore
					onShowAlert(
						err,
						err.response.data.message || err.response.data.error
					);
				}
			}

			setIsLoading(false);
		}
	};

	const onContinue = async (data?: WalletPayProps) => {
		setIsLoading(true);
		const payload = {
			email: userEmail,
			fullname: fullname,
			amount,
			currency,
			paymentType: payData.kit?.paymentType || 'html-checkout',
            productType: payData.kit.productType ?? "COLLECTION",
			sourceAmount: payData.kit?.sourceAmount,
			phone_number: payData.kit?.phone_number,
			tx_ref: payData.kit?.tx_ref,
			rate: payData.details?.rate,
			sourceCurrency: payData.sourceCurrency,
			paylinkToken: payData.kit.paylinkToken,
		};

		try {
			const response = await axios(
				`${process.env.REACT_APP_API_URL}pay/wallet/business/make/payment`,
				{
					method: 'POST',
					headers: {
						'Content-Type': 'application/json',
						Accept: 'application/json',
						'x-auth-token': merchantKey,
                        ...(process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN && {
                            "x-fe-token": process.env.REACT_APP_DASHBOARD_ACCESS_TOKEN
                          })
					},
					data: payload,
				}
			);
			const responseData = response.data;
			if (responseData.error) {
				setIsLoading(false);
				return;
			} else if (responseData.status === 'error') {
				return;
			} else {
				setIsLoading(false);
				setTabDisplayed('success');
				setPageTransactionStatus('success');
				const sendData = {
					status: 'successful',
					txnRef: responseData.walletTnxId,
					tnxRef: responseData.walletTnxId,
					tx_ref: responseData.walletTnxId,
					amount: responseData.amount,
				};
				setTimeout(() => {
					sendMessage(sendData);
				}, 5000);
			}
		} catch (err) {
			setTabDisplayed('error');
			setPageTransactionStatus('error');
			setTimeout(() => {
				sendMessage({ status: 'ERROR',  tnxRef: payData.kit.tx_ref });
			}, 5000);
		}
		// setIsLoading(false);
	};

	if (tabDisplayed === 'error' || tabDisplayed === 'success') {
		return <StatusMessage type={tabDisplayed} />;
	}

	return (
		<MobileWrapper>
			<div className={styles.container}>
				<div className={styles.main}>
					<Header email={email} />
					<AmountSection
						amount={amount}
						currency={payData?.details?.currency}
					/>
					<div className={styles.body}>
						{tabDisplayed === 'login' && (
							<Login
								onPay={onPay}
								isLoading={isLoading}
								emailError={emailError}
								setEmailError={setEmailError}
							/>
						)}
						{tabDisplayed === 'details' && (
							<Details
								email={userEmail}
								fullName={fullname}
								onContinue={onContinue}
								isLoading={isLoading}
							/>
						)}
					</div>
					<BackToMethods />
				</div>
				<SupportEmail />
			</div>
		</MobileWrapper>
	);
};
